import { render, staticRenderFns } from "./accountingSettings.vue?vue&type=template&id=b71c9226&scoped=true&"
import script from "./accountingSettings.vue?vue&type=script&lang=js&"
export * from "./accountingSettings.vue?vue&type=script&lang=js&"
import style0 from "./accountingSettings.vue?vue&type=style&index=0&id=b71c9226&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71c9226",
  null
  
)

export default component.exports